var r;!function(r){r.START="start",r.END="end"}(r||(r={}));var t=20;export{t as LIST_ITEM_ICON_SIZE,r as ListItemIconMargin};
